import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAxiosByRole } from "../../utils/getAxiosByRole.js";

export const fetchVideoAccess = createAsyncThunk(
  "video/fetchVideoAccess",
  async ({ bookingId, role }, { rejectWithValue }) => {
    try {
      const axios = getAxiosByRole(role);
      const res = await axios.get(`/video/video-access/${bookingId}`);
      // console.log("Fetxh", res);

      return res.data; // { access: true, roomId, peerId }
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Access error" });
    }
  }
);

export const fetchPeerInfo = createAsyncThunk(
  "video/fetchPeerInfo",
  async ({ bookingId, role }, { rejectWithValue }) => {
    try {
      const axios = getAxiosByRole(role);
      const res = await axios.get(`/video/${bookingId}/peer-info`);

      return res.data; // { name: "John Smith" }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Peer fetch error" }
      );
    }
  }
);
